import React, {useState} from "react";
import Iban from 'iban';

export function FormPartText(props) {
    let {formPart, saveFunction, lang, errors, hasError, register, isIdentificationNumber, isNumeric} = props;
    const maxLength = 65535;
    const [maxLengthError, setMaxLengthError] = useState(false)
    const [invalidFormatError, setInvalidFormatError] = useState(false)


	const getValidatorTypePlaceholder = (type) => {
		switch (type) {
			case null:
			case 'text':
				return null
			case 'personalId':
				return window.Translator.getSlug('FormatPersonalId', lang)
			case 'iban':
				return window.Translator.getSlug('FormatIban', lang)
			case 'number':
				return window.Translator.getSlug('FormatNumber', lang)
		}
	}

    return (<div className={'form-group'}>
        <label className={' '} htmlFor={'input-' + formPart.id}>{formPart.label}</label>
		<span style={{color: "grey", fontSize: "12px"}}>{getValidatorTypePlaceholder(formPart.validator.type)}</span>
        <input
            className={formPart.required ? 'form-control requiredField ' : 'form-control'}
            name={'input-' + formPart.id}
            id={'input-' + formPart.id}
            required={formPart.required}
            onBlur={(event) => saveFunction(event, formPart.id, 'text')}
            ref={register({required: formPart.required})}
            onChange={(event) => {
                if (new Blob([event.target.value]).size > maxLength) {
                    setMaxLengthError(true)
                } else {
                    setMaxLengthError(false)
                }
				if (event.target.value === '')
					setInvalidFormatError(false)

                switch (formPart.validator.type) {
                    case 'text':
                    case null:
                        break
                    case 'iban':
						setInvalidFormatError(!Iban.isValid(event.target.value))
                        break
                    case 'personalId':
						setInvalidFormatError(!isIdentificationNumber(event.target.value))
                        break
                    case 'number':
						setInvalidFormatError(!isNumeric(event.target.value))
                        break
                }
            }}
        />
        {maxLengthError && (
            <span className="form-error-message">{window.Translator.getSlug('MaxCharactersWarning', lang)}</span>)}
        {hasError('input-' + formPart.id, errors) && (<span
            className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', lang)}</span>)}
        {invalidFormatError && (<span
            className="form-error-message">{window.Translator.getSlug('InvalidFormat', lang)}</span>)}
    </div>);
}
